import React, { type FC, useEffect, useState } from "react";
import { parse } from "date-fns";
import * as locale from "date-fns/locale";

interface ScheduledVisibilityBoxProps {
  children: React.ReactNode;
  startDate: string;
  endDate: string;
}

export const ScheduledVisibilityBox: FC<ScheduledVisibilityBoxProps> = ({ children, startDate, endDate }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const now = new Date();

    const start = parse(startDate, "yyyy-MM-dd HH:mm:ss", new Date(), { locale: locale.ja });
    const end = parse(endDate, "yyyy-MM-dd HH:mm:ss", new Date(), { locale: locale.ja });

    // 現在時刻が表示期間内かどうかをチェック
    if (now >= start && now <= end) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [startDate, endDate]);

  return <>{isVisible ? children : null}</>;
};
